export default "__VITE_ASSET__DDvRL_7O__"